import React, { useState, useEffect } from 'react';
/* eslint-disable */
import * as Yup from 'yup';

// material
import { Container } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';

import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, InputAdornment } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import TokenDecoder from 'src/helpers/TokenDecoder';
import services from './../Service'
import 'react-toastify/dist/ReactToastify.css';




export default function ChangePassword(props) {

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [userName, setUserName] = useState("");
  const [isButtonEnable, setIsButtonEnable] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    userID: "",
    newPassword: "",
    oldPassword: "",
    confirmPassword: "",
  });

  const changePasswordSchema = Yup.object().shape({
    newPassword: Yup.string().required('New Password is required'),
    oldPassword: Yup.string().required('Old Password is required'),
    confirmPassword: Yup.string().required('Password is required'),
  });
  const formik = useFormik({
    initialValues: {
      userID: formData.userID,
      newPassword: formData.newPassword,
      oldPassword: formData.oldPassword,
      confirmPassword: formData.confirmPassword
    },
    validationSchema: changePasswordSchema,
    onSubmit: (values) => {
      ChangePassword(values, userName);
    }
  });
  const handleKeyDown = e => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };

  useEffect(() => {
    setForEdit(formik.values.userID)
  }, []);

  useEffect(() => {
    if (formik.values.oldPassword != "" && formik.values.newPassword != "" && formik.values.confirmPassword != "") {
      setIsButtonEnable(true)
    } else {
      setIsButtonEnable(false)
    }
  }, [formik.values.oldPassword, formik.values.newPassword, formik.values.confirmPassword]);

  async function setForEdit(id) {
    var id = parseInt(TokenDecoder.getUserIDFromToken());
    let userDetailsRes = await services.getUserByID(id);
    if (userDetailsRes != null) {
      setValues({
        userName: userDetailsRes.userName
      })
      setUserName(userDetailsRes.userName);
    }
  }
  async function ChangePassword(values, userName) {
    if (values.newPassword.length > 5) {
      if (values.newPassword == values.confirmPassword) {
        var res = await services.ChangePassword(values, userName);
        if (res.statusCode === "Success") {
          toast.success("Password Reset Succesfully");
          setTimeout(() => {
            navigate('/login');
          }, 2000);

        } else {
          toast.error(res.message);
        }
      }
      else {
        toast.error("New Password and Confirm Password not match.");
      }
    }
    else {
      toast.error("New Password should be at least 6 digits.");
    }
  }

  async function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  return (
    <Page title="Change Password |  FAPS">
      <Container>
        <CommonPageHeader
          path={'/createfirstForcast'}
          pageName="Change Password "
          leftButtonHidden={true}
        />
        <FormikProvider value={formik}>
          <ToastContainer
            position="bottom-right"
            pauseOnHover
          />
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Stack spacing={3}>
              {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField
                  fullWidth
                  hidden={true}
                  size="small"
                  //label="User Name *"
                  value={formik.values.userName}
                  disabled={true}
                  onChange={formik.handleChange}
                  onKeyDown={handleKeyDown}
                  {...getFieldProps('userName')}
                  error={Boolean(touched.userName && errors.userName)}
                  helperText={touched.userName && errors.userName}
                />
              </Stack> */}
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField
                  fullWidth
                  size="small"
                  autoComplete="current-password"
                  type={showOldPassword ? 'text' : 'password'}
                  value={formik.values.oldPassword}
                  onChange={formik.handleChange}
                  onKeyDown={handleKeyDown}
                  label="Old Password *"
                  {...getFieldProps('oldPassword')}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton edge="end" onClick={() => setShowOldPassword((prev) => !prev)}>
                          <Icon icon={showOldPassword ? eyeFill : eyeOffFill} />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  error={Boolean(touched.oldPassword && errors.oldPassword)}
                  helperText={touched.oldPassword && errors.oldPassword}
                />
                <TextField
                  fullWidth
                  size="small"
                  autoComplete="current-password"
                  type={showPassword ? 'text' : 'password'}
                  value={formik.values.newPassword}
                  onChange={formik.handleChange}
                  onKeyDown={handleKeyDown}
                  label="New Password *"
                  {...getFieldProps('newPassword')}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton edge="end" onClick={() => setShowPassword((prev) => !prev)}>
                          <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  error={Boolean(touched.newPassword && errors.newPassword)}
                  helperText={touched.newPassword && errors.newPassword}
                />
                <TextField
                  fullWidth
                  size="small"
                  autoComplete="current-password"
                  type={showConfirmPassword ? 'text' : 'password'}
                  label="Confirm Password *"
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  onKeyDown={handleKeyDown}
                  {...getFieldProps('confirmPassword')}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton edge="end" onClick={() => setShowConfirmPassword((prev) => !prev)}>
                          <Icon icon={showConfirmPassword ? eyeFill : eyeOffFill} />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                  helperText={touched.confirmPassword && errors.confirmPassword}
                />
              </Stack>
              <Divider variant="middle" />
              <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                <LoadingButton type="submit" color="secondary" variant="outlined">
                  Change Password
                </LoadingButton>
              </Stack>
            </Stack>
          </Form>
        </FormikProvider>
      </Container>
    </Page>
  );
}
